
import { Routes, Route } from "react-router-dom";

import HomePage from "@/pages/home";
import DashboardPage from "@/pages/dashboard";
import AuthPage from "@/pages/auth";
import SignUpPage from "@/pages/sign-up";
import AdminPage from "@/pages/admin";
import AdminClientsPage from "@/pages/admin/clients";
import AdminContactPage from "@/pages/admin/contact/[id]";
import AdminLeadsPage from "@/pages/admin/leads";
import AdminSalesPage from "@/pages/admin/sales";
import AdminNewClientPage from "@/pages/admin/new-client";
import AdminIdCardsPage from "@/pages/admin/id-cards";
import AdminPaymentsPage from "@/pages/admin/payments";
import AdminPoliciesPage from "@/pages/admin/policies";
import AdminEmployeesPage from "@/pages/admin/employees";
import AdminEmployeeDetailsPage from "@/pages/admin/employees/[id]";
import AdminFieldsPage from "@/pages/admin/fields";
import DashboardIdCardsPage from "@/pages/dashboard/id-cards";
import DashboardPaymentsPage from "@/pages/dashboard/payments";
import DashboardMyPoliciesPage from "@/pages/dashboard/my-policies";
import DashboardClaimsPage from "@/pages/dashboard/claims";
import QuotePage from "@/pages/quote";
import AboutPage from "@/pages/about";
import FAQPage from "@/pages/faq";
import ClaimsProcessPage from "@/pages/claims-process";
import PrivacyPolicyPage from "@/pages/privacy-policy";
import TermsPage from "@/pages/terms";
import CityPage from "@/pages/city/[name]";
import AutoInsurancePage from "@/pages/insurance/auto";
import HomeInsurancePage from "@/pages/insurance/home";
import LifeInsurancePage from "@/pages/insurance/life";
import BusinessInsurancePage from "@/pages/insurance/business";

function App() {
  console.log("App component rendering");
  
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/dashboard/id-cards" element={<DashboardIdCardsPage />} />
      <Route path="/dashboard/payments" element={<DashboardPaymentsPage />} />
      <Route path="/dashboard/my-policies" element={<DashboardMyPoliciesPage />} />
      <Route path="/dashboard/claims" element={<DashboardClaimsPage />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/sign-up" element={<SignUpPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/admin/clients" element={<AdminClientsPage />} />
      <Route path="/admin/contact/:id" element={<AdminContactPage />} />
      <Route path="/admin/leads" element={<AdminLeadsPage />} />
      <Route path="/admin/sales" element={<AdminSalesPage />} />
      <Route path="/admin/new-client" element={<AdminNewClientPage />} />
      <Route path="/admin/id-cards" element={<AdminIdCardsPage />} />
      <Route path="/admin/payments" element={<AdminPaymentsPage />} />
      <Route path="/admin/policies" element={<AdminPoliciesPage />} />
      <Route path="/admin/employees" element={<AdminEmployeesPage />} />
      <Route path="/admin/employees/:id" element={<AdminEmployeeDetailsPage />} />
      <Route path="/admin/fields" element={<AdminFieldsPage />} />
      <Route path="/quote" element={<QuotePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/faq" element={<FAQPage />} />
      <Route path="/claims-process" element={<ClaimsProcessPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/city/:name" element={<CityPage />} />
      <Route path="/insurance/auto" element={<AutoInsurancePage />} />
      <Route path="/insurance/home" element={<HomeInsurancePage />} />
      <Route path="/insurance/life" element={<LifeInsurancePage />} />
      <Route path="/insurance/business" element={<BusinessInsurancePage />} />
    </Routes>
  );
}

export default App;
